import React from 'react';
import ContainerComponent from './ContainerComponent';

interface Props {
  item: {
    label: string;
    subtype: string;
  };
}

const HeaderFieldComponent: React.FC<Props> = ({ item: { label, subtype } }) => {
  return <ContainerComponent header={label} subtype={subtype} />;
};

export default HeaderFieldComponent;
